import { Progress } from '@/components/ui/progress';
import { cn } from '@/lib/utils';
import { randomNumber } from '@/utils/numbers';
import { useEffect, useState } from 'react';

type LoadingProps = {
	className?: string;
};
export function Loading({ className }: LoadingProps) {
	const [progress, setProgress] = useState(5);

	useEffect(() => {
		const timer = setInterval(
			() => setProgress(prevProgress => Math.min(90, prevProgress + randomNumber(30, 50))),
			1000
		);
		return () => clearTimeout(timer);
	}, []);

	return <Progress value={progress} className={cn('w-full absolute top-0', className)} />;
}
